import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BOOK_URL, M } from "../lib/site";
import { MaskLines, FadeUp } from "./Reveal";

const POINTS = [
  ["Bottomless", "10PM – 12AM"],
  ["Live DJs", "RNB, House & Afro House"],
  ["Late Nights", "Doors 9PM til late"],
];

export const Bottomless = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="bottomless" ref={ref} className="relative overflow-hidden bg-[var(--velvet)]/40 py-24 sm:py-36" data-testid="bottomless-section">
      <div className="pointer-events-none absolute left-1/4 top-1/3 h-[480px] w-[480px] rounded-full bg-[var(--rose)] opacity-20 blur-[160px]" />
      <div className="relative mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-10 lg:grid-cols-12 lg:gap-20">
        <div className="relative lg:col-span-5">
          <div className="relative mx-auto aspect-[3/4] w-full max-w-[460px] overflow-hidden rounded-t-[999px] rounded-b-[28px] border border-[var(--line)]">
            <motion.img style={{ y, scale: 1.25 }} src={M.champagne} alt="Champagne flute in front of a copper mirror ball"
              className="h-full w-full object-cover" loading="lazy" data-testid="bottomless-photo" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_30%,rgba(9,8,11,0.7)_100%)]" />
          </div>
          <div className="absolute -bottom-6 left-1/2 flex h-32 w-32 -translate-x-1/2 flex-col items-center justify-center rounded-full border border-[var(--glow)] bg-[#09080B] sm:left-auto sm:right-0 sm:translate-x-0" data-testid="bottomless-hours-badge">
            <span className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-[var(--stone)]">Bottomless</span>
            <span className="mt-1 text-center font-display text-xl leading-tight text-[var(--glow)]">10PM<br />– 12AM</span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="eyebrow mb-6">02 — Bottomless Packages</p>
          <MaskLines lines={["Bottomless", "Fridays."]}
            className="font-display text-6xl leading-[0.9] text-[#F8F6F0] sm:text-7xl lg:text-8xl" />
          <FadeUp delay={0.15}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-[var(--stone)] sm:text-lg">
              Bottomless packages run from <span className="text-[var(--glow)]">10PM to 12AM</span> — book for you and your crew, then stay for the DJs til late.
            </p>
            <div className="mt-10 grid gap-px overflow-hidden rounded-2xl border border-[var(--line)] bg-[var(--line)] sm:grid-cols-3">
              {POINTS.map(([t, d]) => (
                <div key={t} className="bg-[#0d0b10] p-6">
                  <p className="font-display text-2xl text-[var(--glow)]">{t}</p>
                  <p className="mt-1 text-sm text-[var(--stone)]">{d}</p>
                </div>
              ))}
            </div>
            <a href={BOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="bottomless-cta-button"
              className="btn-gold mt-10 inline-flex items-center gap-3 rounded-full px-9 py-5 text-[13px] font-semibold uppercase tracking-[0.2em]">
              Book Your Bottomless Package <ArrowUpRight size={16} />
            </a>
            <p className="mt-4 text-xs text-[var(--stone)]">Bottomless available 10PM – 12AM · Bookings via thevaliant.au</p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
